import React, { useEffect, useState } from 'react';
import { RELEASE_NOTES } from '../config/app';
import { markReleaseSeen, shouldShowReleaseNotes } from '../utils/appRelease';
import { Button, ModalPortal } from './ui';

export const WhatsNewModal: React.FC = () => {
  const [open, setOpen] = useState(() => shouldShowReleaseNotes(RELEASE_NOTES));

  const title = (RELEASE_NOTES?.title || 'What’s new').trim() || 'What’s new';
  const body = (RELEASE_NOTES?.body || '').trim();

  const dismiss = () => {
    markReleaseSeen(RELEASE_NOTES?.id);
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      markReleaseSeen(RELEASE_NOTES?.id);
      setOpen(false);
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [open]);

  if (!open) return null;

  return (
    <ModalPortal>
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 print:hidden">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={dismiss} />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="whats-new-title"
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
      >
        <div className="flex items-center justify-between px-5 pt-5 pb-3 border-b border-gray-100">
          <h2 id="whats-new-title" className="text-base font-bold text-gray-900">{title}</h2>
          <button
            type="button"
            onClick={dismiss}
            className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="px-5 py-4">
          <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">
            {body || 'A new version of Passport is available.'}
          </p>
        </div>
        <div className="px-5 py-4 border-t border-gray-100">
          <Button type="button" onClick={dismiss} fullWidth>
            Got it
          </Button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};
